<script setup>
import CaseStudiesContent from "~/components/molecules/CaseStudiesContent.vue";
</script>

<template>
  <CaseStudiesContent />
</template>
